var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: "新增版本信息",
            width: "750px",
            top: "2vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm12",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新标题", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入更新标题", clearable: "" },
                        model: {
                          value: _vm.ruleForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "title", $$v)
                          },
                          expression: "ruleForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新内容", prop: "main" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 1, maxRows: 6 },
                          placeholder: "输入更新内容",
                          resize: "none",
                        },
                        model: {
                          value: _vm.ruleForm.main,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "main", $$v)
                          },
                          expression: "ruleForm.main",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台类型", prop: "osType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.changeOsType },
                          model: {
                            value: _vm.ruleForm.osType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "osType", $$v)
                            },
                            expression: "ruleForm.osType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("安卓"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("苹果"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本号", prop: "versionCode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder:
                            "当前包版本号，必须大于当前线上发行版本号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.ruleForm.versionCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "versionCode", $$v)
                          },
                          expression: "ruleForm.versionCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.osType === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "下载链接", prop: "link" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "填写下载链接，复制粘贴APP打包-云编译后的包链接",
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.link,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "link", $$v)
                              },
                              expression: "ruleForm.link",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.osType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "AppStore", prop: "iosLink" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "APP上线苹果后台后获取",
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.iosLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "iosLink", $$v)
                              },
                              expression: "ruleForm.iosLink",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "强制更新", prop: "forceBoole" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.ruleForm.forceBoole,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "forceBoole", $$v)
                          },
                          expression: "ruleForm.forceBoole",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "打开后，APP的升级弹窗无法关闭",
                            placement: "right",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "vertical-align": "middle",
                                "margin-left": "10px",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上线发行", prop: "onlineBoole" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.ruleForm.onlineBoole,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "onlineBoole", $$v)
                          },
                          expression: "ruleForm.onlineBoole",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "打开后，替换当前线上发行版本，若当前处于上线状态，无法直接关闭",
                            placement: "right",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "vertical-align": "middle",
                                "margin-left": "10px",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "邀请码功能设置", prop: "inviteConfig" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.inviteConfig,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "inviteConfig", $$v)
                            },
                            expression: "ruleForm.inviteConfig",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("跟随系统默认"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("版本自定义"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "right" },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v("控制当前版本登录时的邀请码是否填写。"),
                              _c("br"),
                              _vm._v(
                                '选择"跟随系统默认"时与【app基础设置-模式设置】保持一致'
                              ),
                              _c("br"),
                              _vm._v(
                                '选择"版本自定义"则可针对当前版本做特定控制'
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "vertical-align": "middle",
                                "margin-left": "10px",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.inviteConfig === 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "当前版本邀请码", prop: "invite" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.invite,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "invite", $$v)
                                },
                                expression: "ruleForm.invite",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("必填"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("不填"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("非必填(可跳过)"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核版本", prop: "examineBoole" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.ruleForm.examineBoole,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "examineBoole", $$v)
                          },
                          expression: "ruleForm.examineBoole",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "应用商店审核时使用，打开后会隐藏部分功能，且邀请码可跳过",
                            placement: "right",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "vertical-align": "middle",
                                "margin-left": "10px",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.examineBoole
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "首页模板", prop: "pageCode" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm.pageCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "pageCode", $$v)
                                },
                                expression: "ruleForm.pageCode",
                              },
                            },
                            _vm._l(_vm.templateList, function (item) {
                              return _c("el-option", {
                                key: item.pageCode,
                                attrs: {
                                  label: item.pageName,
                                  value: item.pageCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm12")
                            },
                          },
                        },
                        [_vm._v("发布")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onClose } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }